import React, { Fragment, useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import CommonImageContainer from './commons/CommonImageContainer'
import ModalBackground from './commons/ModalBackground'
import ModalPopupContainer from './commons/ModalPopup'

import replaceLocation from '../../../utils/replaceLocation'
import getGatsbyImage from '../../../utils/getGatsbyImage'

export default function ModalButtonSection({
  slice,
}: {
  slice: Queries.PrismicPageDataBodyModalButton
}) {
  const item = slice.primary
  const buttonItems = slice.items
  const image = getGatsbyImage(item.modal_button_image?.localFile)
  const [modalActive, setModalActive] = useState<boolean>(false)

  const handleClickImage = () => {
    switch (item.modal_button_target_user) {
      case 'ALL':
        setModalActive(true)
        break
      default:
        item.modal_button_target_uri_web &&
          replaceLocation(
            item.modal_button_target_uri_web ||
              item.modal_button_target_uri ||
              '',
          )
        break
    }
    return
  }

  const handleClickMoveurlButton = (url: string) => {
    if (url) {
      replaceLocation(url)
    }
    setModalActive(false)
    return
  }

  const handleClickModalOffButton = () => {
    setModalActive(false)
  }

  const handleClickOutBoundOfModal = () => {
    setModalActive(false)
  }

  if (image) {
    return (
      <Fragment>
        <CommonImageContainer onClick={handleClickImage}>
          <GatsbyImage
            style={{ width: '100%' }}
            image={image}
            alt={item.modal_button_image?.alt ?? ''}
          />
        </CommonImageContainer>
        {modalActive && (
          <ModalBackground>
            <ModalPopupContainer
              title={
                item.modal_button_modal_text_web || item.modal_button_modal_text
              }
              buttonItems={buttonItems}
              shadow={item.modal_button_modal_shadow_effect_color}
              onClickMoveUrlButton={handleClickMoveurlButton}
              onClickModalOffButton={handleClickModalOffButton}
              onClickOutBoundModal={handleClickOutBoundOfModal}
            />
          </ModalBackground>
        )}
      </Fragment>
    )
  }
  return null
}
